module.exports = __webpack_public_path__ + "img/marked-test.57a2852a.svg";